// Centralised links & content references
export const LINKS = {
  // Internal integrated pages (previously external landing pages)
  moneyFlowSession: "/money-flow-session",
  financialLeadership: "/advisory",
  followTheCash: "/follow-the-cash",
  // External assessment (lead-gen)
  freeAssessment: "https://assessment.profitmind.co.uk",
  // Sister product
  forecastly: "https://forecastly.me",
  // Booking
  tidycal: "https://schedule.profitmind.co.uk/free-20min-chat",
  advisoryFitCall: "https://schedule.profitmind.co.uk/advisory-fit-call",
  // Stripe (Money Flow Session direct purchase)
  moneyFlowStripe: "https://payments.profitmind.co.uk/b/fZufZ9gVZ6Gg9ukavHeZ201",
  // Contact
  email: "hello@profitmind.co.uk",
  // Social
  linkedinPersonal: "https://uk.linkedin.com/in/magdalena-mahdy",
  linkedinCompany: "https://uk.linkedin.com/company/profitminduk",
  instagram: "https://www.instagram.com/profitminduk/",
};

export const ASSETS = {
  logo: "/images/logo.png",
  forecastlyLogo: "/images/forecastly-logo.png",
  // Magdalena photos
  portraitFull: "/images/portrait-full.jpg",
  portraitProfile: "/images/portrait-profile.jpg",
  coffeeLaptop: "/images/coffee-laptop.jpg",
  portraitYellowBg: "/images/portrait-yellow-bg.jpg",
  portraitLaughingStripes: "/images/portrait-laughing-stripes.jpg",
  // July 2026 refresh
  heroProfile: "/images/magdalena-profile-01.webp",
  waysToWorkPortrait: "/images/ways-to-work-alt.jpg",
  founderStory: "/images/magdalena-outdoor-laptop.jpg",
  photographerCamera: "/images/magdalena-photographer-camera.jpg",
  photographerWedding: "/images/magdalena-photographer-wedding.jpg",
  aboutHero: "/images/about-hero-2.webp",
  advisoryHero: "/images/about-hero.webp",
  workWithMeHero: "/images/work-with-me-hero.jpg",
  moneyFlowHero: "/images/money-flow-hero.jpg",
};

export const BRAND = {
  name: "ProfitMIND",
  parent: "ProfitMIND LTD",
  founder: "Magdalena Mahdy",
  tagline: "Profitable But Broke · Follow The Cash · Own Your Future",
  mantra: "Turnover is Vanity. Profit is Sanity. Cash is Queen.",
  region: "Essex, United Kingdom",
};
